import { Inject, Injectable, LOCALE_ID, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import * as fromAuth from '../../user/reducers';
import { User } from 'src/app/user/models/user';
import { MagentoStore } from '../models/magento-store';


@Injectable({providedIn: 'root'})
export class StoreService {

    readonly stores: {[id: string]: MagentoStore} = {
        "US": {
            id: "US",
            storeCode: "b2b_us",
            websiteId: 8,
            storeId: 5,
            currency: "USD"
        },
        "EN": {
            id: "EN",
            storeCode: "b2b_en",
            websiteId: 2,
            storeId: 2,
            currency: "EUR"
        },
        "DE": {
            id: "DE",
            storeCode: "b2b_de",
            websiteId: 2,
            storeId: 3,
            currency: "EUR"
        }
    }

    user: User;

    constructor(@Inject(LOCALE_ID) private localeId: string, private store: Store<fromRoot.State>) {
        this.store.pipe(select(fromAuth.getUser)).subscribe((user) => this.user = user);
    }

    getStoreCode(): string {
        if (this.isStoreUS()) {
            console.log("The user is registered in US Website. Returning US store")
            return this.stores.US.storeCode
        }

        return this.stores[this.localeId.split("-")[0].toUpperCase()].storeCode
    }

    getStoreId(): number{
        return this.stores[this.localeId.split("-")[0].toUpperCase()].storeId
    }

    getStoreCurrency(): string {
        if (this.isStoreUS()) {
            return this.stores.US.currency
        }
        return this.stores[this.localeId.split("-")[0].toUpperCase()].currency
    }

    isStoreUS(): boolean {
        return this.user ? this.user.website_id === this.stores.US.websiteId : false
    }
}
